import { FC, memo, useMemo } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import { IPagination } from 'src/types/main';
import { numberWithDigitSeparator } from '~/utils/formatter';
import './style.scss';

interface IProps {
  pagination: IPagination<any>;
  showPaginationInfo: boolean;
}

const PaginationInfo: FC<IProps> = ({ pagination, showPaginationInfo }: IProps): JSX.Element | null => {
  const numberOfEntries = useMemo((): string | null => {
    if (!showPaginationInfo) return null;
    const { current_page, per_page, last_page, total } = pagination;

    const first: number = current_page * per_page - per_page + 1;
    const last: number = last_page === current_page ? first + (total % per_page) - 1 : current_page * per_page;

    return localeStore.t('number_of_entries', {
      ordinal_number_of_the_first_row_on_the_page: first,
      ordinal_number_of_the_last_row_on_the_page: last,
      total_number_of_rows_in_the_table: numberWithDigitSeparator(total),
    });
  }, [pagination, showPaginationInfo]);

  if (!numberOfEntries) return null;

  return (
    <div className="pagination-info">
      <p className="pagination-info__text">{numberOfEntries}</p>
    </div>
  );
};

export default memo(PaginationInfo);
